export default "__VITE_PUBLIC_ASSET__bc58b3dc__"